var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinnedPnc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90431 0.788662C7.0769 0.489729 7.45915 0.387307 7.75808 0.559896L13.5316 3.89323C13.8305 4.06582 13.9329 4.44806 13.7603 4.74699C13.5878 5.04593 13.2055 5.14835 12.9066 4.97576L12.0873 4.50274L10.3929 8.72399C10.5843 9.0367 10.7451 9.36572 10.8706 9.70685C11.3484 11.0059 11.2761 12.3832 10.6204 13.5189C10.4478 13.8178 10.0656 13.9202 9.76662 13.7477L5.97776 11.5602L4.20693 14.6273C4.03434 14.9263 3.6521 15.0287 3.35316 14.8561C3.05423 14.6835 2.95181 14.3013 3.1244 14.0023L4.89523 10.9352L1.10637 8.74766C0.807437 8.57507 0.705016 8.19283 0.877604 7.89389C1.53332 6.75816 2.68991 6.00693 4.05383 5.77121C4.412 5.7093 4.77733 5.68403 5.14384 5.69343L7.95237 2.11545L7.13308 1.64243C6.83415 1.46984 6.73172 1.08759 6.90431 0.788662Z",
    fill: "#CE0202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnedPnc);
export default __webpack_public_path__ + "static/media/pinnedPnc.4b101f74af1cf5b4053d6d0868942335.svg";
export { ForwardRef as ReactComponent };